import { isNumber, zl } from "../../../functions/utilities";

const WodaOdczytyRazemSzczegolyWm2 = props => {

    const { wybraneRozliczenie } = props;

    return (
        <div className="blok">
            <div className="woda-wiersz">
                <p className="opis">
                    Moc zamówiona: 
                </p>
                <p className="zuzycie">
                    {`${zl(wybraneRozliczenie?.mocZamowiona)}`}
                </p>
            </div>
            <div className="woda-wiersz">
                <p className="opis">
                    Energia pobrana:
                </p>
                <p className="zuzycie">
                    {`${zl(wybraneRozliczenie?.energiaPobrana)}`}
                </p>
            </div>
            <div className="woda-wiersz">
                <p className="opis">
                    Abonament na dzień za m² (wg PWiK):
                </p>
                <p className="zuzycie">
                    {`${zl(wybraneRozliczenie?.abonament_dzien, 6)}`}
                </p>
            </div>
        </div>
    )
}

export default WodaOdczytyRazemSzczegolyWm2;